import * as Sentry from '@sentry/vue'

const dsn = document.querySelector('meta[name="sentry-dsn"]')?.getAttribute('content')

if (dsn) {
  Sentry.init({
    dsn,
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
    ignoreErrors: [
      /Failed to fetch/i,
      /NetworkError/i,
      /Load failed/i,
      /Clipboard write is not allowed/i
    ],
    beforeSend (event) {
      if (event.request?.query_string) {
        event.request.query_string = ''
      }

      if (event.request?.url) {
        event.request.url = event.request.url.replace(/(\/[sdep]\/)(\w{5})[^/]+/, '$1$2')
      }

      return event
    }
  })
}
